
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class vModal extends Vue {
  @Prop() show!: boolean;
  @Prop() modalTitle!: string;
  @Prop() size?: string;
  @Prop() modalId?: string;
  @Prop({ default: false }) hideInPrint: boolean;
  @Prop({ default: true }) centered: boolean;

  @Watch("show")
  showModal() {
    let htmlBodyElement = document.getElementsByTagName("body")[0];
    if (this.show) {
      htmlBodyElement.classList.add("modalOpen");
      this.$emit("openModal");
    }

    else {
      htmlBodyElement.classList.remove("modalOpen");
    }
  }

  hideModal() {
    this.$emit("hideModal");
  }

  cancelModal() {
    this.$emit("cancelModal");
  }

  mounted() {
    document.addEventListener("keydown", (e) => {
      if (this.show && e.keyCode == 27) {
        this.cancelModal();
      }
    });
  }
}
